export let hrms17eColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRAP32EC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRAP32EC1',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codcomp',
      name: '',
      labelCodapp: 'HRAP32EC1',
      labelIndex: '100',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'HRAP32EC1',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'dteefpos',
      name: '',
      labelCodapp: 'HRAP32EC1',
      labelIndex: '120',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRAP32EC1',
      labelIndex: '130',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }
  ]
  let detail1TableColumns = [
    {
      key: 'kpino',
      name: '',
      labelCodapp: 'HRAP32EC2',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;',
      validateRules: 'max:2'
    }, {
      key: 'kpiitem',
      name: '',
      labelCodapp: 'HRAP32EC2',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'kpiwgt',
      name: '',
      labelCodapp: 'HRAP32EC2',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 100px;'
    }
  ]
  let detail2Tab1TableColumns = [
    {
      key: 'workno',
      name: '',
      labelCodapp: 'HRAP32EP1',
      labelIndex: '140',
      class: 'align-center',
      style: 'width: 100px;',
      inlineType: 'number',
      decimal: 0,
      validateRules: 'max:2'
    }, {
      key: 'workitem',
      name: '',
      labelCodapp: 'HRAP32EP1',
      labelIndex: '150',
      style: 'min-width: 300px;',
      inlineType: 'text',
      validateRules: 'max:300'
    }
  ]
  let detail2Tab2TableColumns = [
    {
      key: 'grdno',
      name: '',
      labelCodapp: 'HRAP32EP2',
      labelIndex: '20',
      class: 'align-center',
      style: 'width: 75px;',
      inlineType: 'number',
      decimal: 0,
      validateRules: 'max:2'
    }, {
      key: 'grditem',
      name: '',
      labelCodapp: 'HRAP32EP2',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 200px;',
      inlineType: 'text',
      validateRules: 'max:2'
    }, {
      key: 'achieve',
      name: '',
      labelCodapp: 'HRAP32EP2',
      labelIndex: '40',
      style: 'min-width: 200px;',
      inlineType: 'text',
      validateRules: 'max:200'
    }, {
      key: 'Ranking',
      name: '',
      labelCodapp: 'HRAP32EP2',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 1,
      colspan: 2,
      rowspan: 1
    }, {
      key: 'mtrvalst',
      name: '',
      labelCodapp: 'HRAP32EP2',
      labelIndex: '60',
      class: 'align-right',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      inlineType: 'number',
      validateRules: 'max:14'
    }, {
      key: 'mtrvalen',
      name: '',
      labelCodapp: 'HRAP32EP2',
      labelIndex: '70',
      class: 'align-right',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      inlineType: 'number',
      validateRules: 'max:14'
    }, {
      key: 'qtyscor',
      name: '',
      labelCodapp: 'HRAP32EP2',
      labelIndex: '80',
      class: 'align-right',
      style: 'min-width: 100px;',
      inlineType: 'number',
      validateRules: 'max:6'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detail1Table: detail1TableColumns,
      detail2Tab1Table: detail2Tab1TableColumns,
      detail2Tab2Table: detail2Tab2TableColumns
    },
    th: {
      index: indexColumns,
      detail1Table: detail1TableColumns,
      detail2Tab1Table: detail2Tab1TableColumns,
      detail2Tab2Table: detail2Tab2TableColumns
    }
  }
}

export let hrms17eMaxRowspan = {
  detail2Tab2Table: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms17e.js